export default "__VITE_ASSET__C8CUqcJU__"